export const STACK_ENV = {
  LocalDev: 'local_dev',
  DevStack: 'dev_stack',
  ProdStack: 'prod_stack',
} as const;

export type StackEnvironment = (typeof STACK_ENV)[keyof typeof STACK_ENV];

export const STACK_ENVIRONMENTS: StackEnvironment[] = Object.values(STACK_ENV);
